import React from 'react'
import { useSelector } from 'react-redux'
import BannerAlert from 'particles/Alert/BannerAlert'
import { useNewTranslation } from 'hooks'
import Label from 'particles/Label'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'
import { selectBankDetailsByEditingCampaignCountry } from 'state/constants'
const BankTransfer: React.FC = () => {
    const [t] = useNewTranslation()
    const bankDetail = useSelector(selectBankDetailsByEditingCampaignCountry)
    return (
        <BankTransferContainer>
            <BannerAlert
                contentType="info"
                title={t('modalWindow.bankTransferInstruction.reminderTitle')}
                subText={t('modalWindow.bankTransferInstruction.reminderSubtext')}
                showClose={false}
            />
            <div className="bank-information">
                <Label title={t('modalWindow.bsnkTransferInstruction.bankInformation.title')} isRequired />
                <BankDetailCardContainer>
                    <div className="row-block">
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.accountName')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.account_name}
                            </Text>
                            {/*  */}
                        </div>
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('withdrawal.bankDetails.accountNumber')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.account_number}
                            </Text>
                        </div>
                    </div>
                    <div className="row-block">
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.bankName')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.bank_name}
                            </Text>
                        </div>
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.bankCode')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.bank_code}
                            </Text>
                        </div>
                    </div>
                    <div className="row-block">
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.branchCode')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.branch_code}
                            </Text>
                        </div>
                        <div className="cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.swiftCode')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.swift_code}
                            </Text>
                        </div>
                    </div>
                    <div className="row-block">
                        <div className="row-cell">
                            <Text scale={'bodyS700'} color="secondary">
                                {t('modalWindow.bankTransferInstruction.bankInformation.bankAddress')}
                            </Text>
                            <Text scale={'bodyL500'} color="primary">
                                {bankDetail?.bank_address}
                            </Text>
                        </div>
                    </div>
                </BankDetailCardContainer>
            </div>
        </BankTransferContainer>
    )
}

export default BankTransfer

const BankTransferContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[400]};
    .bank-information {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[200]};
    }
`

const BankDetailCardContainer = styled.div`
    box-sizing: border-box;
    font-family: inherit;
    width: 552px;
    min-height: 200px;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.surface.primary};
    border: 2px solid ${({ theme }) => theme.colors.border.primary};
    padding: 12px;
    display: flex;
    gap: ${({ theme }) => theme.spacing[400]};
    flex-direction: column;

    .row-block {
        display: flex;
        gap: ${({ theme }) => theme.spacing[400]};
    }
    .cell {
        width: 256px;
    }
    .row-cell {
        display: flex;
        flex-direction: column;
    }
`
